export * from '../services/storage.service';
export * from './storage.component';
export * from './form/form.component';


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/storage/index.ts